import OpenAI from 'openai'

let client = null

function getStoredKey() {
  const local = localStorage.getItem('bravo-sim-openai-key') || localStorage.getItem('bravo-tax-openai-key')
  return local || null
}

export function getApiKeyStatus() {
  const envKey = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_OPENAI_API_KEY) || null
  const stored = getStoredKey()
  if (envKey) return { isConfigured: true, source: 'env' }
  if (stored) return { isConfigured: true, source: 'localStorage' }
  return { isConfigured: false, source: null }
}

export function initializeOpenAI(apiKey) {
  if (!apiKey || typeof apiKey !== 'string' || apiKey.length < 10) {
    throw new Error('API key inválida')
  }
  localStorage.setItem('bravo-sim-openai-key', apiKey)
  localStorage.removeItem('bravo-tax-openai-key')
  client = new OpenAI({ apiKey, dangerouslyAllowBrowser: true })
  return true
}

export function getOpenAIClient() {
  if (client) return client
  const envKey = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_OPENAI_API_KEY) || null
  const key = envKey || getStoredKey()
  if (!key) return null
  client = new OpenAI({ apiKey: key, dangerouslyAllowBrowser: true })
  return client
}
